module.exports = {
  "/": {},
  "/crm": {
    "success": {
      "default": [
        "FREE_TOOLS_PAGE"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "freePage"
  },
  "/bundle": {
    "success": {
      "default": [
        "BUNDLE_PAGE"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "bundlePage"
  },
  "/marketing": {
    "success": {
      "default": [
        "MARKETING_PAGE"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "marketingPage"
  },
  "/sales": {
    "success": {
      "default": [
        "SALES_PAGE"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "salesPage"
  },
  "/service": {
    "success": {
      "default": [
        "SERVICE_PAGE"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "servicePage"
  },
  "/cms": {
    "success": {
      "default": [
        "CMS_PAGE"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "cmsPage"
  },
  "/content": {
    "success": {
      "default": [
        "CMS_PAGE"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "contentPage"
  },
  "/data": {
    "success": {
      "default": [
        "OPERATIONS_PAGE"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "dataPage"
  },
  "/commerce": {
    "success": {
      "default": [
        "COMMERCE_PAGE"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "commercePage"
  },
  "/suite": {
    "success": {
      "default": [
        "SUITE_PAGE"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "suitePage"
  },
  "/marketing-plus": {
    "success": {
      "default": [
        "MARKETING_PLUS_PAGE"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "marketingPlusPage"
  },
  "/smart-crm": {
    "success": {
      "default": [
        "SMART_CRM_PAGE"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "smartCrmPage"
  },
  "/marketing/:tab": {
    "success": {
      "default": [
        "MARKETING_PAGE"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "marketingPagePublic"
  },
  "/sales/:tab": {
    "success": {
      "default": [
        "SALES_PAGE"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "salesPagePublic"
  },
  "/service/:tab": {
    "success": {
      "default": [
        "SERVICE_PAGE"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "servicePagePublic"
  },
  "/cms/:tab": {
    "success": {
      "default": [
        "CMS_PAGE"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "cmsPagePublic"
  },
  "/content/:tab": {
    "success": {
      "default": [
        "CMS_PAGE"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "contentPagePublic"
  },
  "/data/:tab": {
    "success": {
      "default": [
        "OPERATIONS_PAGE"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "dataPagePublic"
  },
  "/suite/:tab": {
    "success": {
      "default": [
        "SUITE_PAGE"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "suitePagePublic"
  },
  "/smart-crm/:tab": {
    "success": {
      "default": [
        "SMART_CRM_PAGE"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "smartCrmPagePublic"
  },
  "/hubspot-credits": {
    "success": {
      "default": [
        "HUBSPOT_CREDITS_PAGE"
      ]
    },
    "error": [
      "FALLBACK_ERROR_BANNER",
      "ERROR_PAGE"
    ],
    "name": "hubSpotCreditsPage"
  }
};